module.exports = __webpack_public_path__ + "img/choose-account.535c9e78.jpg";